import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select, { components } from "react-select";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import AOS from "aos";
import "aos/dist/aos.css";
import { usePageTitle } from "../PageTitleContext";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { CloseIcon, SearchesCIcon } from "../../Static/icons/iconshere";
import apiClient from "../../apiClient";
import { RESOURCE_TYPE_APPLICATION, XR_MODULE_CREATE } from "../../apiClient/apiEndpoints";
import PublishedList from "./publishedList";
import UnPublishedList from "./unPublishedList";
import { remoteReviewModuleData } from "../../store/slice/moduleSlice";
import Filter from "../Filter/Filter";
import { useDebounce } from "../../hooks/useDebounce";
import CsvModuleUpload from "./csvModule";
import { checkUserAllowPermissions } from "../../utils/common";
import { CONTENT_XR_CREATE } from "../../constant/Permissions";

const Dashboard = () => {
  const dispatch = useDispatch();
  const configData = useSelector((state) => state.configSlice);
  const tagsData = useSelector((state) => state.tagsSlice);
  const userData = useSelector((state) => state.userSlice);
  const [moduleName, setModuleName] = useState("");
  const [searchText, setSearchText] = useState("");
  const [activeKey, setActiveKey] = useState("published");
  const [error, setError] = useState(null);
  const [applicationList, setApplicationList] = useState([]);
  const [applicationTagsOptions, setApplicationTagsOptions] = useState([]);
  const [selectedApplications, setSelectedApplications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showCsvModal, setShowCsvModal] = useState(false);

  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [selectedCategoryCheckboxes, setSelectedCategoryCheckboxes] = useState([]);

  const [showAddModule, setShowAddModule] = useState(false);
  const { setPageTitle } = usePageTitle();

  const getResourceTypeApplication = async () => {
    try {
      let data = await apiClient.get(`${configData.config.UNO_URL}${RESOURCE_TYPE_APPLICATION}/MODULE`);
      let list = data.list.map((e) => {
        return {
          icon: e.icon,
          label: e.name,
          value: e.uuid,
        };
      });
      setApplicationList(data.list);
      setApplicationTagsOptions(list);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setPageTitle("XR Modules");
    getResourceTypeApplication();
  }, []);

  const handleSelect = (key) => {
    setActiveKey(key);
  };

  useEffect(() => {
    AOS.init();
    AOS.refresh();
    dispatch(remoteReviewModuleData());
  }, []);

  const createModule = async () => {
    setLoading(true);
    setError(null);
    if (moduleName.trim().length == 0) {
      setError("Fill module name.");
      return;
    }

    let allIds = [];

    let createModule = {
      name: moduleName,
      tags: allIds,
      applicationsIds: selectedApplications.map((e) => e.value),
    };

    try {
      await apiClient.post(`${configData.config.UNO_URL}${XR_MODULE_CREATE}`, createModule);
      closeModal();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const openModal = () => {
    setModuleName("");
    setError(null);
    setShowAddModule(true);
    const xrTag = applicationTagsOptions.find((item) => item?.value === "e9dfc406-b05b-4bfe-a254-2dc4007a3363");
    if (xrTag) {
      setSelectedApplications([xrTag]);
    }
  };

  const closeModal = () => {
    setError(null);
    setShowAddModule(false);
  };

  const handleCancelTag = (item) => {
    setSelectedCheckboxes((prevSelected) => prevSelected.filter((selectedItem) => selectedItem !== item));
    setSelectedCategoryCheckboxes((prevSelected) => prevSelected.filter((selectedItem) => selectedItem !== item));
  };

  const CustomMultiValueRemove = (props) => {
    if (props.data.value === "e9dfc406-b05b-4bfe-a254-2dc4007a3363") {
      return null;
    }
    return <components.MultiValueRemove {...props} />;
  };

  const debouncedSearchText = useDebounce(searchText, 500);
  const filterOptions = tagsData?.allTagsList?.children?.filter((e) => e.name != "Sectors") || [];

  const openCsvModal = () => {
    setShowCsvModal(true);
  };

  const handleCloseCsvModule = () => setShowCsvModal(false);

  return (
    <>
      <div className="filterhere">
        <Tabs activeKey={activeKey} onSelect={handleSelect}>
          <Tab eventKey="published" title="Published" />
          <Tab eventKey="unpublished" title="Unpublished" />
        </Tabs>
      </div>

      <div className="stuckhere modules">
        <div className="row">
          <div className="col-md-6"> </div>
          <div className="col-md-6  d-flex align-items-center gap-3 justify-content-end mainbtns">
            <form className=" app-search app-search1 d-flex justify-content-start ">
              <div className="position-relative">
                <SearchesCIcon />
                <input
                  placeholder="Search Modules...."
                  className="form-control"
                  type="text"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
            </form>

            {/* <button onClick={openCsvModal} className="createbtn">
              Upload CSV
            </button> */}

            {checkUserAllowPermissions(CONTENT_XR_CREATE) && activeKey === "published" && (
              <button onClick={openModal} className="createbtn">
                Add Modules
              </button>
            )}

            <Filter
              selectedCheckboxes={selectedCheckboxes}
              setSelectedCheckboxes={setSelectedCheckboxes}
              filterOptions={filterOptions}
              categoryOptions={tagsData.categoryList}
              selectedCategoryCheckboxes={selectedCategoryCheckboxes}
              setSelectedCategoryCheckboxes={setSelectedCategoryCheckboxes}
            />
          </div>
          <div className="col-md-12">
            {[...selectedCheckboxes, ...selectedCategoryCheckboxes].length > 0 && (
              <div className="filerlist mt-3">
                <span>Filters:</span>
                {[...selectedCheckboxes, ...selectedCategoryCheckboxes].map((f) => {
                  return (
                    <span className="filtertag">
                      {f.name}
                      <span onClick={() => handleCancelTag(f)}>
                        <CloseIcon />
                      </span>
                    </span>
                  );
                })}
                <span
                  className="filtertag clear"
                  onClick={() => {
                    setSelectedCheckboxes([]);
                    setSelectedCategoryCheckboxes([]);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  Clear all
                </span>
              </div>
            )}
          </div>
        </div>
      </div>

      <div>
        {activeKey === "published" && (
          <PublishedList
            searchText={debouncedSearchText}
            selectedCheckboxes={selectedCheckboxes}
            selectedCategoryCheckboxes={selectedCategoryCheckboxes}
          />
        )}
        {activeKey === "unpublished" && (
          <UnPublishedList
            searchText={debouncedSearchText}
            selectedCheckboxes={selectedCheckboxes}
            selectedCategoryCheckboxes={selectedCategoryCheckboxes}
          />
        )}
      </div>

      <Modal show={showAddModule} onHide={() => setShowAddModule(false)} className="NewModule" centered size="md">
        <Modal.Header className="modalheader">
          Enter Module Details
          <span onClick={() => setShowAddModule(false)}>
            <CloseIcon />
          </span>
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 mb-2">
                <div className="form-group">
                  <label className="label">Name</label>
                  <input
                    autoComplete="off"
                    placeholder="Module Name"
                    name="moduleName"
                    id="moduleName"
                    value={moduleName}
                    onChange={(e) => setModuleName(e.target.value)}
                    className="input form-control"
                    type="text"
                  />
                </div>
                {error && <p className="error"> {error} </p>}
              </div>
              <div className="col-12 mb-2">
                <div className="form-group">
                  <label className="label">Application</label>

                  <Select
                    isMulti
                    name="applications"
                    isClearable={false}
                    className="basic-multi-select mt-2"
                    classNamePrefix="select"
                    placeholder="Select Applications"
                    options={applicationTagsOptions}
                    value={selectedApplications}
                    onChange={setSelectedApplications}
                    components={{ MultiValueRemove: CustomMultiValueRemove }}
                    filterOption={(option, inputValue) => option.label.toLowerCase().includes(inputValue.toLowerCase())}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="footerbtn pt-0">
          <Button onClick={closeModal}> Cancel </Button>
          <Button onClick={createModule} disabled={loading}>
            {" "}
            Save{" "}
          </Button>
        </Modal.Footer>
      </Modal>

      <CsvModuleUpload
        showCsvModule={showCsvModal}
        handleCloseCsvModule={handleCloseCsvModule}
      />
    </>
  );
};

export default Dashboard;
